import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from "./router";
import store from "./store";
import excel from 'vue-excel-export';
import VueDaumPostcode from "vue-daum-postcode";

Vue.use(excel);
Vue.use(VueDaumPostcode);

Vue.config.productionTip = false  //vue처음 실행시 경고문출력 (false로 설정)

new Vue({
  vuetify,
  router,
  store,      
  beforeCreate() {                      
    // this.$store.dispatch("CheckLogin"); //페이지 열람확인을 위해서는 반드시 설정필요
  },
  render: h => h(App)
}).$mount('#app')
